<div class="flex flex-row gap-(--gap-normal)">
  <div class="w-64 pr-(--space-4)">
    <div
      class="mb-(--space-4) flex justify-start items-center gap-(--gap-tight)"
      role="toolbar"
      aria-labelledby="measure-actions-label">
      <span id="measure-actions-label" class="sr-only">{{ 'entities.measureFormula.sections.measureActions' | transloco }}</span>
      <ces-button-secondary
        [hasPermission]="writePermission()"
        [label]="'common.buttons.add' | transloco"
        size="small"
        icon="add"
        (onClick)="createFormula()" />
      @if (canSuspendNow()) {
        <ces-button-secondary
          [hasPermission]="writePermission()"
          [label]="'entities.measureFormula.messages.suspendAction' | transloco"
          size="small"
          icon="pause"
          [disabled]="isProcessing()"
          (onClick)="confirmSuspend()" />
      }
      @if (canReactivateNow()) {
        <ces-button-secondary
          [hasPermission]="writePermission()"
          [label]="'entities.measureFormula.messages.reactivateAction' | transloco"
          size="small"
          icon="play_arrow"
          [disabled]="isProcessing()"
          (onClick)="confirmReactivate()" />
      }
    </div>
    @if (measureFormulas().length > 0) {
      <div class="overflow-y-auto">
        <ul class="list-none p-0 m-0">
          @for (formula of measureSortedFormulas(); track formula.id) {
            <li>
              <a
                [routerLink]="[]"
                [fragment]="'formula-' + formula.id"
                class="block bg-transparent p-(--space-2) transition-colors border-y-0 border-r-0 border-l-2"
                [ngClass]="formulaClassesMap().get(formula.id)"
                (click)="selectFormula(formula.id)">
                <div class="flex flex-col">
                  <span
                    class="text-sm flex flex-row items-start gap-(--gap-tight)"
                    [class.font-semibold]="selectedFormulaId() === formula.id">
                    {{
                      'entities.measureFormula.messages.fromDate'
                        | transloco: { date: (formula.startTs | date: fromDateFormat(formula.id)) }
                    }}
                    @if (t.testMode()) {
                      <span>#{{ formula.id }}</span>
                    }
                  </span>
                  @switch (formulaStatuses().get(formula.id)) {
                    @case ('active-since') {
                      <span class="text-xs text-green-600 mt-(--space-1)">
                        {{
                          'entities.measureFormula.status.activeSince'
                            | transloco: { date: (formula.startTs | date: fromDateFormat(formula.id)) }
                        }}
                      </span>
                    }
                    @case ('active-from') {
                      <span class="text-xs text-blue-600 mt-(--space-1)">
                        {{
                          'entities.measureFormula.status.activeFrom'
                            | transloco: { date: (formula.startTs | date: fromDateFormat(formula.id)) }
                        }}
                      </span>
                    }
                    @case ('suspended-since') {
                      <span class="text-xs text-orange-600 mt-(--space-1)">
                        {{
                          'entities.measureFormula.status.suspendedSince'
                            | transloco: { date: (formula.startTs | date: fromDateFormat(formula.id)) }
                        }}
                      </span>
                    }
                    @case ('suspended-from') {
                      <span class="text-xs text-orange-600 mt-(--space-1)">
                        {{
                          'entities.measureFormula.status.suspendedFrom'
                            | transloco: { date: (formula.startTs | date: fromDateFormat(formula.id)) }
                        }}
                      </span>
                    }
                    @case ('expired-active') {
                      <span class="text-xs text-(color:--text-secondary) mt-(--space-1)">
                        {{
                          'entities.measureFormula.status.expiredActive'
                            | transloco: { date: (formula.endTs | date: toDateFormat(formula.id)) }
                        }}
                      </span>
                    }
                    @case ('expired-suspended') {
                      <span class="text-xs text-(color:--text-secondary) mt-(--space-1)">
                        {{
                          'entities.measureFormula.status.expiredSuspended'
                            | transloco: { date: (formula.endTs | date: toDateFormat(formula.id)) }
                        }}
                      </span>
                    }
                  }
                  @if (formula.formula?.comment || formula.suspendComment) {
                    <span class="text-xs text-(color:--text-secondary) mt-(--space-1) truncate">{{
                      formula.formula?.comment || formula.suspendComment
                    }}</span>
                  }
                </div>
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <div class="flex-1 bg-(--surface-2) p-(--padding-card) rounded-(--radius-lg)">
    @if (measureFormulas().length > 0) {
      @if (selectedFormula(); as formula) {
        <div class="flex flex-col gap-(--gap-loose)">
          <div class="flex justify-between">
            <div>
              <section class="mb-(--space-4)">
                <h3 class="font-semibold text-sm mb-(--space-2)">
                  @if (selectedIsInactive()) {
                    {{ 'entities.measureFormula.sections.inactivePeriod' | transloco }}
                  } @else {
                    {{ 'entities.measureFormula.sections.validity' | transloco }}
                  }
                </h3>
                <div class="flex gap-(--gap-loose)">
                  <ces-property [label]="'entities.measureFormula.fields.validityFrom' | transloco">
                    {{ formula.startTs | date: 'dd.MM.yyyy HH:mm' }}
                  </ces-property>
                  <ces-property [label]="'entities.measureFormula.fields.validityUntil' | transloco">
                    @if (selectedFormulaNextStart(); as nextStart) {
                      {{ nextStart | date: 'dd.MM.yyyy HH:mm' }}
                    } @else {
                      {{ 'entities.measureFormula.fields.validityUntilNone' | transloco }}
                    }
                  </ces-property>
                </div>
              </section>

              @if (t.testMode()) {
                <div class="text-(color:--text-primary) text-xs">Début : {{ formula.startTs }}</div>
                <div class="text-(color:--text-primary) text-xs">Fin : {{ formula.endTs }}</div>
              }
            </div>
            <div class="flex gap-(--gap-normal)">
              @if (!selectedIsInactive()) {
                <ces-button-secondary
                  [hasPermission]="writePermission()"
                  icon="edit"
                  [label]="'common.buttons.edit' | transloco"
                  size="small"
                  (onClick)="editFormula(formula)" />
              }
              @if (selectedIsInactive()) {
                <ces-button-secondary
                  [hasPermission]="writePermission()"
                  icon="edit"
                  [label]="'common.buttons.edit' | transloco"
                  size="small"
                  [disabled]="isProcessing()"
                  (onClick)="editInactivePeriod()" />
              }
              @if (t.testMode()) {
                <ces-delete-button
                  size="small"
                  (confirm)="deleteFormula(formula)"
                  [confirmationConfig]="deleteConfirmationConfig(formula)" />
              }
            </div>
          </div>

          @if (!selectedIsInactive()) {
            <ces-property [label]="'common.labels.comment' | transloco">{{ formula.formula?.comment || '-' }}</ces-property>

            <div>
              <div class="cursor-default select-none text-label mb-(--space-1)">{{ 'common.labels.parameters' | transloco }}</div>
              <ces-parameters-display
                [parametersInput]="formula.formula?.parameters"
                [unitsInput]="units()"
                [measuresInput]="otherMeasures()"
                [mode]="ParameterMode.FORMULA"
                [emptyMessage]="'entities.measureFormula.messages.emptyFormulaParams' | transloco" />
            </div>

            <div>
              <div class="cursor-default select-none text-label mb-(--space-1)">{{ 'common.labels.expression' | transloco }}</div>
              <ces-expression-display [formula]="formula.formula" />
            </div>
          } @else {
            @if (formula.suspendComment) {
              <ces-property [label]="'common.labels.comment' | transloco">{{ formula.suspendComment }}</ces-property>
            }

            @if (resumeFormula(); as resumeForm) {
              <section
                class="mt-(--gap-loose) p-(--padding-card) bg-(--surface-0) rounded-(--radius-md) border-l-4 border-l-blue-400 flex flex-col gap-(--gap-loose)">
                <h4 class="font-medium text-sm text-(color:--text-primary) flex items-center gap-(--gap-tight) m-0">
                  <ces-icon aria-hidden="true" translate="no" class="text-base leading-none">replay</ces-icon>
                  @if (formula.endTs) {
                    {{
                      'entities.measureFormula.sections.resumeScheduled'
                        | transloco: { date: (formula.endTs | date: 'dd.MM.yyyy HH:mm') }
                    }}
                  } @else {
                    {{ 'entities.measureFormula.sections.formulaOnResume' | transloco }}
                  }
                </h4>

                <div>
                  <div class="cursor-default select-none text-label mb-(--space-1)">{{ 'common.labels.parameters' | transloco }}</div>
                  <ces-parameters-display
                    [parametersInput]="resumeForm.parameters"
                    [unitsInput]="units()"
                    [measuresInput]="otherMeasures()"
                    [mode]="ParameterMode.FORMULA"
                    [emptyMessage]="'entities.measureFormula.messages.emptyFormulaParams' | transloco" />
                </div>

                <div>
                  <div class="cursor-default select-none text-label mb-(--space-1)">{{ 'common.labels.expression' | transloco }}</div>
                  <ces-expression-display [formula]="resumeForm" />
                </div>
              </section>
            }
          }
        </div>
      } @else {
        <div class="flex flex-col items-center justify-center align-middle h-full">
          {{ 'entities.measureFormula.messages.selectFromList' | transloco }}
        </div>
      }
    } @else {
      {{ 'entities.measureFormula.messages.noneFound' | transloco }}
    }
  </div>
</div>
